// tslint:disable
import { Injectable } from '@angular/core';

import { DwItem, DwItemDetail, DwQuery, DwOrmData } from '@devwareapps/devware-cap';
import * as EnterpriseMetaData from '@devwareapps/devware-cap';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

/************************************************
   Generated with the Devware CAP CLI 4.4.37
   Code Gen Name   Notes
   API Url         https://wappsdev.wachter.com/DevwareCapApi/

   Generated By    MSI/mlt
   Generate On     1/12/2024 2:02:05 PM
************************************************/

export enum NotesMetaDataItemNames {
    EthosUser = 'Ethos_User',
    EthosUserDiff = 'Ethos_UserDiff',
    EthosUserSkill = 'Ethos_UserSkill',
    NotesNote = 'notes_Note',
    NotesNoteParent = 'notes_NoteParent',
    NoteType = 'NoteType',
    RoEthosUser = 'roEthos_User',
    RoEthosUserOriginal = 'roEthos_UserOriginal',
}

export enum NotesMetaDataLookups {
    EmployeesByDeptIncTrainees = 2812,
    EthosUserBySupervisor = 1758,
    EthosUserBySupervisorPlusIndirect = 1773,
    EthosUserByUsersDepartment = 1582,
    ETHOSUSERNSPLBUOfficeActiveEmployees = 1696,
    ETHOSUSERWachterEmployeesActiveEmployees = 1464,
    EthosUserAllItems = 1416,
    EthosUserDiffAllItems = 1623,
    EthosUserEmployeeGroups = 2858,
    EthosUserSkillAllItems = 1413,
    NoteAllItems = 1804,
    NoteParentAllItems = 1805,
    NoteTypeAllItems = 1839,
    RoEthosUserActiveOnly = 2837,
    RoEthosUserAllActiveThenInactive = 2889,
    RoEthosUserAllItems = 1422,
    RoEthosUserOriginalAllItems = 1753,
}

@Injectable({
    providedIn: 'root'
})
export class NotesMetaDataService {

    EthosUser : EthosUserMetaData = new EthosUserMetaData();
    EthosUserDiff : EthosUserDiffMetaData = new EthosUserDiffMetaData();
    EthosUserSkill : EthosUserSkillMetaData = new EthosUserSkillMetaData();
    NotesNote : NotesNoteMetaData = new NotesNoteMetaData();
    NotesNoteParent : NotesNoteParentMetaData = new NotesNoteParentMetaData();
    NoteType : NoteTypeMetaData = new NoteTypeMetaData();
    RoEthosUser : RoEthosUserMetaData = new RoEthosUserMetaData();
    RoEthosUserOriginal : RoEthosUserOriginalMetaData = new RoEthosUserOriginalMetaData();
}

// Generated Classes for MetaData service
export class EthosUserMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_User.';

    constructor() {
        this.ItemDetail.ItemId=2413;
        this.ItemDetail.ItemName='Ethos_User';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserId : string = this.i + 'UserId';
    UserName : string = this.i + 'UserName';
    FirstName : string = this.i + 'FirstName';
    LastName : string = this.i + 'LastName';
    MiddleName : string = this.i + 'MiddleName';
    PreferredName : string = this.i + 'PreferredName';
    Suffix : string = this.i + 'Suffix';
    OfficePhone : string = this.i + 'OfficePhone';
    MobilePhone : string = this.i + 'MobilePhone';
    WachterJobTitleId : string = this.i + 'WachterJobTitleId';
    WachterJobTitle : string = this.i + 'WachterJobTitle';
    UserTypeCv : string = this.i + 'UserTypeCv';
    UserTypeDisplay : string = this.i + 'UserTypeDisplay';
    StaffingAgencyId : string = this.i + 'StaffingAgencyId';
    ResourceGroupCv : string = this.i + 'ResourceGroupCv';
    ResourceGroup : string = this.i + 'ResourceGroup';
    EmployeeGroupId : string = this.i + 'EmployeeGroupId';
    EmployeeGroupCode : string = this.i + 'EmployeeGroupCode';
    EmployeeGroupDescription : string = this.i + 'EmployeeGroupDescription';
    EmpHireDate : string = this.i + 'empHireDate';
    AddressLongitude : string = this.i + 'AddressLongitude';
    AddressLatitude : string = this.i + 'AddressLatitude';
    WachterTeamId : string = this.i + 'WachterTeamId';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    BirthMonth : string = this.i + 'BirthMonth';
    BirthDate : string = this.i + 'BirthDate';
    Email : string = this.i + 'Email';
    SupervisorUserId : string = this.i + 'SupervisorUserId';
    UserStatusWs : string = this.i + 'UserStatusWs';
    UserStatusMeaning : string = this.i + 'UserStatusMeaning';
    IsTerminated : string = this.i + 'IsTerminated';
    PictureAttachmentFileExtension : string = this.i + 'PictureAttachmentFileExtension';
    PictureAttachmentDisplay : string = this.i + 'PictureAttachmentDisplay';
    PictureAttachmentField : string = this.i + 'PictureAttachmentField';
    AdjustedStartDate : string = this.i + 'AdjustedStartDate';
    OfficeId : string = this.i + 'OfficeId';
    OfficeName : string = this.i + 'OfficeName';
    StreetAddress1 : string = this.i + 'StreetAddress1';
    StreetAddress2 : string = this.i + 'StreetAddress2';
    City : string = this.i + 'City';
    StateProvinceShortName : string = this.i + 'StateProvinceShortName';
    PostalCode : string = this.i + 'PostalCode';
    HasVehicle : string = this.i + 'HasVehicle';
    ShowUserOnMap : string = this.i + 'ShowUserOnMap';
    RowInsertDateTime : string = this.i + 'RowInsertDateTime';
    EmployeeType : string = this.i + 'EmployeeType';
    StateProvinceId : string = this.i + 'StateProvinceId';
    PictureAttachmentFileKey : string = this.i + 'PictureAttachmentFileKey';
    CustomerId : string = this.i + 'CustomerId';
    SubcontractorId : string = this.i + 'SubcontractorId';
    SpecialInstructions : string = this.i + 'SpecialInstructions';
    IsVaxxed : string = this.i + 'isVaxxed';

    Relations = {
            /** Relation: Ethos User - Supervisor User - One */
            EthosUserBySupervisorUserId : {
                RelationName: 'Supervisor_User',
                FieldPrefix: 'SupervisorEthosUser',
                PropertyName: 'SupervisorEthosUser'
            },
            /** Relation: Ethos User Diff - Many */
            EthosUserDiffByEthosUserId : {
                RelationName: 'Ethos_User|Ethos_UserDiff|Ethos_UserId',
                FieldPrefix: 'EthosEthosUserDiff',
                PropertyName: 'EthosEthosUserDiff'
            },
            /** Relation: User Skill */
            EthosUserSkill : {
                RelationName: 'Ethos_User|Ethos_UserSkill|UserId',
                FieldPrefix: 'EthosUserSkill',
                PropertyName: 'EthosUserSkill'
            },
            /** Relation: Note - Created By - Many */
            NotesNoteByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|notes_Note|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosNotesNote',
                PropertyName: 'CreatedByEthosNotesNote'
            },
            /** Relation: Note - Modified By - Many */
            NotesNoteByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|notes_Note|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosNotesNote',
                PropertyName: 'ModifiedByEthosNotesNote'
            },
            /** Relation: Ro Ethos User */
            RoEthosUser : {
                RelationName: 'Ethos_User|roEthos_User|UserId',
                FieldPrefix: 'RoEthosUser',
                PropertyName: 'RoEthosUser'
            },
            /** Relation: Ro Ethos User - Supervisor - Many */
            RoEthosUserBySupervisorUserId : {
                RelationName: 'Ethos_User|roEthos_User|SupervisorUserId',
                FieldPrefix: 'SupervisorRoEthosUser',
                PropertyName: 'SupervisorRoEthosUser'
            },
    };
}

export class EthosUserDiffMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_UserDiff.';

    constructor() {
        this.ItemDetail.ItemId=2572;
        this.ItemDetail.ItemName='Ethos_UserDiff';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EthosUserDiffId : string = this.i + 'Ethos_UserDiffId';
    EthosUserId : string = this.i + 'Ethos_UserId';
    FieldName : string = this.i + 'FieldName';
    OldValue : string = this.i + 'OldValue';
    NewValue : string = this.i + 'NewValue';
    ChangedDateTime : string = this.i + 'ChangedDateTime';

    Relations = {
            /** Relation: Ethos User - User */
            EthosUserByEthosUserId : {
                RelationName: 'Ethos_User|Ethos_UserDiff|Ethos_UserId',
                FieldPrefix: 'EthosEthosUser',
                PropertyName: 'EthosEthosUser'
            },
    };
}

export class EthosUserSkillMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_UserSkill.';

    constructor() {
        this.ItemDetail.ItemId=2410;
        this.ItemDetail.ItemName='Ethos_UserSkill';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserSkillId : string = this.i + 'UserSkillId';
    UserId : string = this.i + 'UserId';
    SkillCv : string = this.i + 'SkillCv';
    Meaning : string = this.i + 'Meaning';
    Display : string = this.i + 'Display';

    Relations = {
            /** Relation: Ethos User */
            EthosUser : {
                RelationName: 'Ethos_User|Ethos_UserSkill|UserId',
                FieldPrefix: 'EthosUser',
                PropertyName: 'EthosUser'
            },
    };
}

export class NotesNoteMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'notes_Note.';

    constructor() {
        this.ItemDetail.ItemId=2697;
        this.ItemDetail.ItemName='notes_Note';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    NoteId : string = this.i + 'NoteId';
    NoteParentId : string = this.i + 'NoteParentId';
    Note : string = this.i + 'Note';
    IsDeleted : string = this.i + 'IsDeleted';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    NoteTypeId : string = this.i + 'NoteTypeId';
    AccessoryData : string = this.i + 'AccessoryData';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';

    Relations = {
            /** Relation: Note Parent */
            NotesNoteParent : {
                RelationName: 'notes_NoteParent|notes_Note|NoteParentId',
                FieldPrefix: 'NotesNoteParent',
                PropertyName: 'NotesNoteParent'
            },
            /** Relation: Note Type */
            NoteType : {
                RelationName: 'NoteType|notes_Note|NoteTypeId',
                FieldPrefix: 'NoteType',
                PropertyName: 'NoteType'
            },
            /** Relation: Ethos User - Created By Ethos User */
            EthosUserByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|notes_Note|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosEthosUser',
                PropertyName: 'CreatedByEthosEthosUser'
            },
            /** Relation: Ethos User - Modified By Ethos User */
            EthosUserByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|notes_Note|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEthosUser',
                PropertyName: 'ModifiedByEthosEthosUser'
            },
    };
}

export class NotesNoteParentMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'notes_NoteParent.';

    constructor() {
        this.ItemDetail.ItemId=2698;
        this.ItemDetail.ItemName='notes_NoteParent';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    NoteParentId : string = this.i + 'NoteParentId';
    CreatedDateTime : string = this.i + 'CreatedDateTime';

    Relations = {
            /** Relation: Note */
            NotesNote : {
                RelationName: 'notes_NoteParent|notes_Note|NoteParentId',
                FieldPrefix: 'NotesNote',
                PropertyName: 'NotesNote'
            },
    };
}

export class NoteTypeMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'NoteType.';

    constructor() {
        this.ItemDetail.ItemId=2732;
        this.ItemDetail.ItemName='NoteType';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    NoteTypeId : string = this.i + 'NoteTypeId';
    NoteType : string = this.i + 'NoteType';
    MetaDataLookupId : string = this.i + 'MetaDataLookupId';

    Relations = {
            /** Relation: Note */
            NotesNote : {
                RelationName: 'NoteType|notes_Note|NoteTypeId',
                FieldPrefix: 'NotesNote',
                PropertyName: 'NotesNote'
            },
    };
}

export class RoEthosUserMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roEthos_User.';

    constructor() {
        this.ItemDetail.ItemId=2419;
        this.ItemDetail.ItemName='roEthos_User';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserId : string = this.i + 'UserId';
    UserName : string = this.i + 'UserName';
    FirstName : string = this.i + 'FirstName';
    LastName : string = this.i + 'LastName';
    MiddleName : string = this.i + 'MiddleName';
    PreferredName : string = this.i + 'PreferredName';
    Suffix : string = this.i + 'Suffix';
    OfficePhone : string = this.i + 'OfficePhone';
    MobilePhone : string = this.i + 'MobilePhone';
    WachterJobTitleId : string = this.i + 'WachterJobTitleId';
    WachterJobTitle : string = this.i + 'WachterJobTitle';
    UserTypeCv : string = this.i + 'UserTypeCv';
    UserTypeDisplay : string = this.i + 'UserTypeDisplay';
    StaffingAgencyId : string = this.i + 'StaffingAgencyId';
    ResourceGroupCv : string = this.i + 'ResourceGroupCv';
    ResourceGroup : string = this.i + 'ResourceGroup';
    EmployeeGroupId : string = this.i + 'EmployeeGroupId';
    EmployeeGroupCode : string = this.i + 'EmployeeGroupCode';
    EmployeeGroupDescription : string = this.i + 'EmployeeGroupDescription';
    EmpHireDate : string = this.i + 'empHireDate';
    AddressLongitude : string = this.i + 'AddressLongitude';
    AddressLatitude : string = this.i + 'AddressLatitude';
    WachterTeamId : string = this.i + 'WachterTeamId';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    BirthMonth : string = this.i + 'BirthMonth';
    BirthDate : string = this.i + 'BirthDate';
    Email : string = this.i + 'Email';
    SupervisorUserId : string = this.i + 'SupervisorUserId';
    UserStatusWs : string = this.i + 'UserStatusWs';
    UserStatusMeaning : string = this.i + 'UserStatusMeaning';
    IsTerminated : string = this.i + 'IsTerminated';
    PictureAttachmentFileExtension : string = this.i + 'PictureAttachmentFileExtension';
    PictureAttachmentDisplay : string = this.i + 'PictureAttachmentDisplay';
    PictureAttachmentField : string = this.i + 'PictureAttachmentField';
    AdjustedStartDate : string = this.i + 'AdjustedStartDate';
    OfficeId : string = this.i + 'OfficeId';
    OfficeName : string = this.i + 'OfficeName';
    StreetAddress1 : string = this.i + 'StreetAddress1';
    StreetAddress2 : string = this.i + 'StreetAddress2';
    City : string = this.i + 'City';
    StateProvinceShortName : string = this.i + 'StateProvinceShortName';
    PostalCode : string = this.i + 'PostalCode';
    HasVehicle : string = this.i + 'HasVehicle';
    ShowUserOnMap : string = this.i + 'ShowUserOnMap';
    RowInsertDateTime : string = this.i + 'RowInsertDateTime';
    TeamName : string = this.i + 'TeamName';
    TeamShortName : string = this.i + 'TeamShortName';
    TeamNickName : string = this.i + 'TeamNickName';
    DepartmentName : string = this.i + 'DepartmentName';
    DepartmentShortName : string = this.i + 'DepartmentShortName';
    WachterDivisionId : string = this.i + 'WachterDivisionId';
    DivisionName : string = this.i + 'DivisionName';
    DivisionShortName : string = this.i + 'DivisionShortName';
    NameLastFirst : string = this.i + 'NameLastFirst';
    NameLastPrefered : string = this.i + 'NameLastPrefered';
    NameLastFirstPrefered : string = this.i + 'NameLastFirstPrefered';
    NameFirstLast : string = this.i + 'NameFirstLast';
    NamePreferedLast : string = this.i + 'NamePreferedLast';
    NameFirstPreferedLast : string = this.i + 'NameFirstPreferedLast';
    NameFirstMiddleLast : string = this.i + 'NameFirstMiddleLast';
    NamePreferedMidInitialLast : string = this.i + 'NamePreferedMidInitialLast';
    NameLastFirstPreferedStatus : string = this.i + 'NameLastFirstPreferedStatus';
    EmployeeType : string = this.i + 'EmployeeType';
    StateProvinceId : string = this.i + 'StateProvinceId';
    PictureAttachmentFileKey : string = this.i + 'PictureAttachmentFileKey';
    NameLastFirstPreferedType : string = this.i + 'NameLastFirstPreferedType';
    IsActive : string = this.i + 'IsActive';
    SpecialInstructions : string = this.i + 'SpecialInstructions';
    BirthMonthDate : string = this.i + 'BirthMonthDate';
    TerritoryId : string = this.i + 'TerritoryId';
    TerritoryName : string = this.i + 'TerritoryName';
    Company : string = this.i + 'Company';
    LicenseCount : string = this.i + 'LicenseCount';
    AXId : string = this.i + 'AXId';
    YrsService : string = this.i + 'YrsService';
    StaffingAgencyName : string = this.i + 'StaffingAgencyName';

    Relations = {
            /** Relation: Ro Ethos User - Supervisor User - One */
            RoEthosUserBySupervisorUserId : {
                RelationName: 'roEthos_User|roEthos_User|SupervisorId',
                FieldPrefix: 'SupervisorRoEthosUser',
                PropertyName: 'SupervisorRoEthosUser'
            },
            /** Relation: Ethos User */
            EthosUser : {
                RelationName: 'Ethos_User|roEthos_User|UserId',
                FieldPrefix: 'EthosUser',
                PropertyName: 'EthosUser'
            },
            /** Relation: Ethos User - Supervisor User */
            EthosUserBySupervisorUserId : {
                RelationName: 'Ethos_User|roEthos_User|SupervisorUserId',
                FieldPrefix: 'SupervisorEthosUser',
                PropertyName: 'SupervisorEthosUser'
            },
    };
}

export class RoEthosUserOriginalMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roEthos_UserOriginal.';

    constructor() {
        this.ItemDetail.ItemId=2661;
        this.ItemDetail.ItemName='roEthos_UserOriginal';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserId : string = this.i + 'UserId';
    AXId : string = this.i + 'AXId';
    UserName : string = this.i + 'UserName';
    FirstName : string = this.i + 'FirstName';
    LastName : string = this.i + 'LastName';
    MiddleName : string = this.i + 'MiddleName';
    PreferredName : string = this.i + 'PreferredName';
    Suffix : string = this.i + 'Suffix';
    OfficePhone : string = this.i + 'OfficePhone';
    MobilePhone : string = this.i + 'MobilePhone';
    WachterJobTitleId : string = this.i + 'WachterJobTitleId';
    WachterJobTitle : string = this.i + 'WachterJobTitle';
    UserTypeCv : string = this.i + 'UserTypeCv';
    UserTypeDisplay : string = this.i + 'UserTypeDisplay';
    EmployeeType : string = this.i + 'EmployeeType';
    StaffingAgencyId : string = this.i + 'StaffingAgencyId';
    ResourceGroupCv : string = this.i + 'ResourceGroupCv';
    ResourceGroup : string = this.i + 'ResourceGroup';
    EmployeeGroupId : string = this.i + 'EmployeeGroupId';
    EmployeeGroupCode : string = this.i + 'EmployeeGroupCode';
    EmployeeGroupDescription : string = this.i + 'EmployeeGroupDescription';
    EmpHireDate : string = this.i + 'empHireDate';
    AddressLongitude : string = this.i + 'AddressLongitude';
    AddressLatitude : string = this.i + 'AddressLatitude';
    WachterTeamId : string = this.i + 'WachterTeamId';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    BirthMonth : string = this.i + 'BirthMonth';
    BirthDate : string = this.i + 'BirthDate';
    BirthMonthDate : string = this.i + 'BirthMonthDate';
    Email : string = this.i + 'Email';
    SupervisorUserId : string = this.i + 'SupervisorUserId';
    UserStatusWs : string = this.i + 'UserStatusWs';
    UserStatusMeaning : string = this.i + 'UserStatusMeaning';
    IsActive : string = this.i + 'IsActive';
    IsTerminated : string = this.i + 'IsTerminated';
    PictureAttachmentFileExtension : string = this.i + 'PictureAttachmentFileExtension';
    PictureAttachmentDisplay : string = this.i + 'PictureAttachmentDisplay';
    PictureAttachmentFileKey : string = this.i + 'PictureAttachmentFileKey';
    PictureAttachmentField : string = this.i + 'PictureAttachmentField';
    AdjustedStartDate : string = this.i + 'AdjustedStartDate';
    OfficeId : string = this.i + 'OfficeId';
    OfficeName : string = this.i + 'OfficeName';
    StreetAddress1 : string = this.i + 'StreetAddress1';
    StreetAddress2 : string = this.i + 'StreetAddress2';
    City : string = this.i + 'City';
    StateProvinceId : string = this.i + 'StateProvinceId';
    StateProvinceShortName : string = this.i + 'StateProvinceShortName';
    TerritoryId : string = this.i + 'TerritoryId';
    TerritoryName : string = this.i + 'TerritoryName';
    PostalCode : string = this.i + 'PostalCode';
    HasVehicle : string = this.i + 'HasVehicle';
    ShowUserOnMap : string = this.i + 'ShowUserOnMap';
    SpecialInstructions : string = this.i + 'SpecialInstructions';
    RowInsertDateTime : string = this.i + 'RowInsertDateTime';
    TeamName : string = this.i + 'TeamName';
    TeamShortName : string = this.i + 'TeamShortName';
    TeamNickName : string = this.i + 'TeamNickName';
    DepartmentName : string = this.i + 'DepartmentName';
    DepartmentShortName : string = this.i + 'DepartmentShortName';
    WachterDivisionId : string = this.i + 'WachterDivisionId';
    DivisionName : string = this.i + 'DivisionName';
    DivisionShortName : string = this.i + 'DivisionShortName';
    Company : string = this.i + 'Company';
    LicenseCount : string = this.i + 'LicenseCount';
    NameLastFirst : string = this.i + 'NameLastFirst';
    NameLastPrefered : string = this.i + 'NameLastPrefered';
    NameLastFirstPrefered : string = this.i + 'NameLastFirstPrefered';
    NameFirstLast : string = this.i + 'NameFirstLast';
    NamePreferedLast : string = this.i + 'NamePreferedLast';
    NameFirstPreferedLast : string = this.i + 'NameFirstPreferedLast';
    NameFirstMiddleLast : string = this.i + 'NameFirstMiddleLast';
    NamePreferedMidInitialLast : string = this.i + 'NamePreferedMidInitialLast';
    NameLastFirstPreferedStatus : string = this.i + 'NameLastFirstPreferedStatus';
    NameLastFirstPreferedType : string = this.i + 'NameLastFirstPreferedType';

    Relations = {
    };
}

export class NotesMetaData {

    static EthosUser : EthosUserMetaData = new EthosUserMetaData();
    static EthosUserDiff : EthosUserDiffMetaData = new EthosUserDiffMetaData();
    static EthosUserSkill : EthosUserSkillMetaData = new EthosUserSkillMetaData();
    static NotesNote : NotesNoteMetaData = new NotesNoteMetaData();
    static NotesNoteParent : NotesNoteParentMetaData = new NotesNoteParentMetaData();
    static NoteType : NoteTypeMetaData = new NoteTypeMetaData();
    static RoEthosUser : RoEthosUserMetaData = new RoEthosUserMetaData();
    static RoEthosUserOriginal : RoEthosUserOriginalMetaData = new RoEthosUserOriginalMetaData();
}
// Generated Entity Interfaces
export interface EthosUserEntity extends DwOrmData {
    // Attributes
    UserId?: number;
    UserName?: string;
    FirstName?: string;
    LastName?: string;
    MiddleName?: string;
    PreferredName?: string;
    Suffix?: string;
    OfficePhone?: string;
    MobilePhone?: string;
    WachterJobTitleId?: number;
    WachterJobTitle?: string;
    UserTypeCv?: number;
    UserTypeDisplay?: string;
    StaffingAgencyId?: number;
    ResourceGroupCv?: number;
    ResourceGroup?: string;
    EmployeeGroupId?: number;
    EmployeeGroupCode?: string;
    EmployeeGroupDescription?: string;
    empHireDate?: string;
    AddressLongitude?: number;
    AddressLatitude?: number;
    WachterTeamId?: number;
    WachterDepartmentId?: number;
    BirthMonth?: number;
    BirthDate?: number;
    Email?: string;
    SupervisorUserId?: number;
    UserStatusWs?: number;
    UserStatusMeaning?: string;
    IsTerminated?: boolean;
    PictureAttachmentFileExtension?: string;
    PictureAttachmentDisplay?: string;
    PictureAttachmentField?: number;
    AdjustedStartDate?: string;
    OfficeId?: number;
    OfficeName?: string;
    StreetAddress1?: string;
    StreetAddress2?: string;
    City?: string;
    StateProvinceShortName?: string;
    PostalCode?: string;
    HasVehicle?: boolean;
    ShowUserOnMap?: boolean;
    RowInsertDateTime?: string;
    EmployeeType?: string;
    StateProvinceId?: number;
    PictureAttachmentFileKey?: string;
    CustomerId?: number;
    SubcontractorId?: number;
    SpecialInstructions?: string;
    isVaxxed?: boolean;

    // Display Attributes
    UserIdDisplay?: string;
    WachterJobTitleIdDisplay?: string;
    UserTypeCvDisplay?: string;
    StaffingAgencyIdDisplay?: string;
    ResourceGroupCvDisplay?: string;
    WachterTeamIdDisplay?: string;
    WachterDepartmentIdDisplay?: string;
    SupervisorUserIdDisplay?: string;
    UserStatusWsDisplay?: string;
    StateProvinceIdDisplay?: string;
    CustomerIdDisplay?: string;

    // Relations
    SupervisorEthosUser? : EthosUserEntity;
    // Duplicate property excluded
    // SupervisorEthosUser : EthosUserEntity;
    // Duplicate property excluded
    // SupervisorEthosUser : EthosUserEntity[];
    EthosEthosUserDiff? : EthosUserDiffEntity[];
    EthosUserSkill? : EthosUserSkillEntity[];
    CreatedByEthosNotesNote? : NotesNoteEntity[];
    ModifiedByEthosNotesNote? : NotesNoteEntity[];
    RoEthosUser? : RoEthosUserEntity;
    SupervisorRoEthosUser? : RoEthosUserEntity[];
    // Duplicate property excluded
    // SupervisorEthosUser : EthosUserEntity[];
}

export interface EthosUserDiffEntity extends DwOrmData {
    // Attributes
    Ethos_UserDiffId?: number;
    Ethos_UserId?: number;
    FieldName?: string;
    OldValue?: string;
    NewValue?: string;
    ChangedDateTime?: string;

    // Display Attributes
    Ethos_UserIdDisplay?: string;

    // Relations
    EthosEthosUser? : EthosUserEntity;
}

export interface EthosUserSkillEntity extends DwOrmData {
    // Attributes
    UserSkillId?: number;
    UserId?: number;
    SkillCv?: number;
    Meaning?: string;
    Display?: string;

    // Display Attributes
    UserIdDisplay?: string;
    SkillCvDisplay?: string;

    // Relations
    EthosUser? : EthosUserEntity;
}

export interface NotesNoteEntity extends DwOrmData {
    // Attributes
    NoteId?: number;
    NoteParentId?: number;
    Note?: string;
    IsDeleted?: boolean;
    CreatedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    NoteTypeId?: number;
    AccessoryData?: number;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;

    // Display Attributes
    NoteParentIdDisplay?: string;
    CreatedByEthos_UserIdDisplay?: string;
    NoteTypeIdDisplay?: string;
    AccessoryDataDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;

    // Relations
    NotesNoteParent? : NotesNoteParentEntity;
    NoteType? : NoteTypeEntity;
    CreatedByEthosEthosUser? : EthosUserEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
}

export interface NotesNoteParentEntity extends DwOrmData {
    // Attributes
    NoteParentId?: number;
    CreatedDateTime?: string;


    // Relations
    NotesNote? : NotesNoteEntity[];
}

export interface NoteTypeEntity extends DwOrmData {
    // Attributes
    NoteTypeId?: number;
    NoteType?: string;
    MetaDataLookupId?: number;


    // Relations
    NotesNote? : NotesNoteEntity[];
}

export interface RoEthosUserEntity extends DwOrmData {
    // Attributes
    UserId?: number;
    UserName?: string;
    FirstName?: string;
    LastName?: string;
    MiddleName?: string;
    PreferredName?: string;
    Suffix?: string;
    OfficePhone?: string;
    MobilePhone?: string;
    WachterJobTitleId?: number;
    WachterJobTitle?: string;
    UserTypeCv?: number;
    UserTypeDisplay?: string;
    StaffingAgencyId?: number;
    ResourceGroupCv?: number;
    ResourceGroup?: string;
    EmployeeGroupId?: number;
    EmployeeGroupCode?: string;
    EmployeeGroupDescription?: string;
    empHireDate?: string;
    AddressLongitude?: number;
    AddressLatitude?: number;
    WachterTeamId?: number;
    WachterDepartmentId?: number;
    BirthMonth?: number;
    BirthDate?: number;
    Email?: string;
    SupervisorUserId?: number;
    UserStatusWs?: number;
    UserStatusMeaning?: string;
    IsTerminated?: boolean;
    PictureAttachmentFileExtension?: string;
    PictureAttachmentDisplay?: string;
    PictureAttachmentField?: number;
    AdjustedStartDate?: string;
    OfficeId?: number;
    OfficeName?: string;
    StreetAddress1?: string;
    StreetAddress2?: string;
    City?: string;
    StateProvinceShortName?: string;
    PostalCode?: string;
    HasVehicle?: boolean;
    ShowUserOnMap?: boolean;
    RowInsertDateTime?: string;
    TeamName?: string;
    TeamShortName?: string;
    TeamNickName?: string;
    DepartmentName?: string;
    DepartmentShortName?: string;
    WachterDivisionId?: number;
    DivisionName?: string;
    DivisionShortName?: string;
    NameLastFirst?: string;
    NameLastPrefered?: string;
    NameLastFirstPrefered?: string;
    NameFirstLast?: string;
    NamePreferedLast?: string;
    NameFirstPreferedLast?: string;
    NameFirstMiddleLast?: string;
    NamePreferedMidInitialLast?: string;
    NameLastFirstPreferedStatus?: string;
    EmployeeType?: string;
    StateProvinceId?: number;
    PictureAttachmentFileKey?: string;
    NameLastFirstPreferedType?: string;
    IsActive?: number;
    SpecialInstructions?: string;
    BirthMonthDate?: string;
    TerritoryId?: number;
    TerritoryName?: string;
    Company?: string;
    LicenseCount?: number;
    AXId?: string;
    YrsService?: number;
    StaffingAgencyName?: string;

    // Display Attributes
    UserIdDisplay?: string;
    WachterJobTitleIdDisplay?: string;
    UserTypeCvDisplay?: string;
    StaffingAgencyIdDisplay?: string;
    ResourceGroupCvDisplay?: string;
    WachterTeamIdDisplay?: string;
    WachterDepartmentIdDisplay?: string;
    SupervisorUserIdDisplay?: string;
    UserStatusWsDisplay?: string;
    StateProvinceIdDisplay?: string;
    TerritoryIdDisplay?: string;

    // Relations
    SupervisorRoEthosUser? : RoEthosUserEntity;
    EthosUser? : EthosUserEntity;
    SupervisorEthosUser? : EthosUserEntity;
    // Duplicate property excluded
    // SupervisorRoEthosUser : RoEthosUserEntity[];
}

export interface RoEthosUserOriginalEntity extends DwOrmData {
    // Attributes
    UserId?: number;
    AXId?: string;
    UserName?: string;
    FirstName?: string;
    LastName?: string;
    MiddleName?: string;
    PreferredName?: string;
    Suffix?: string;
    OfficePhone?: string;
    MobilePhone?: string;
    WachterJobTitleId?: number;
    WachterJobTitle?: string;
    UserTypeCv?: number;
    UserTypeDisplay?: string;
    EmployeeType?: string;
    StaffingAgencyId?: number;
    ResourceGroupCv?: number;
    ResourceGroup?: string;
    EmployeeGroupId?: number;
    EmployeeGroupCode?: string;
    EmployeeGroupDescription?: string;
    empHireDate?: string;
    AddressLongitude?: number;
    AddressLatitude?: number;
    WachterTeamId?: number;
    WachterDepartmentId?: number;
    BirthMonth?: number;
    BirthDate?: number;
    BirthMonthDate?: string;
    Email?: string;
    SupervisorUserId?: number;
    UserStatusWs?: number;
    UserStatusMeaning?: string;
    IsActive?: number;
    IsTerminated?: boolean;
    PictureAttachmentFileExtension?: string;
    PictureAttachmentDisplay?: string;
    PictureAttachmentFileKey?: string;
    PictureAttachmentField?: number;
    AdjustedStartDate?: string;
    OfficeId?: number;
    OfficeName?: string;
    StreetAddress1?: string;
    StreetAddress2?: string;
    City?: string;
    StateProvinceId?: number;
    StateProvinceShortName?: string;
    TerritoryId?: number;
    TerritoryName?: string;
    PostalCode?: string;
    HasVehicle?: boolean;
    ShowUserOnMap?: boolean;
    SpecialInstructions?: string;
    RowInsertDateTime?: string;
    TeamName?: string;
    TeamShortName?: string;
    TeamNickName?: string;
    DepartmentName?: string;
    DepartmentShortName?: string;
    WachterDivisionId?: number;
    DivisionName?: string;
    DivisionShortName?: string;
    Company?: number;
    LicenseCount?: number;
    NameLastFirst?: string;
    NameLastPrefered?: string;
    NameLastFirstPrefered?: string;
    NameFirstLast?: string;
    NamePreferedLast?: string;
    NameFirstPreferedLast?: string;
    NameFirstMiddleLast?: string;
    NamePreferedMidInitialLast?: string;
    NameLastFirstPreferedStatus?: string;
    NameLastFirstPreferedType?: string;


    // Relations
}



